import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Tabs, Tab, Icon } from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Components
import CleaningKanban from "layouts/cleaning/components/CleaningKanban";

function Cleaning() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname === "/cleaning" ? 0 : location.pathname === "/cleaning-status" ? 1 : 2;

  const handleTabChange = (event, newValue) => {
    if (newValue === 0) navigate("/cleaning");
    else if (newValue === 1) navigate("/cleaning-status");
    else if (newValue === 2) navigate("/rooms");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={{ xs: 1.5, sm: 3 }} px={{ xs: 1, sm: 1.5, md: 2 }}>

        {/* ── Tab Bar (FDO Panel style) ── */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 2, sm: 3 } }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            centered
            sx={{
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .MuiTab-root": {
                fontWeight: 600,
                textTransform: "none",
                fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                mx: { xs: 0.5, sm: 0.5 },
                px: { xs: 1.5, sm: 2, md: 3 },
                py: 1,
                borderRadius: "12px",
                transition: "all 0.3s ease",
                color: "#4b5563",
                backgroundColor: "transparent",
                minWidth: { xs: "55px", sm: "120px" },
                "&:hover": {
                  backgroundColor: "#f3f4f6",
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "& .MuiTab-iconWrapper": {
                  marginBottom: 0,
                  marginRight: 0,
                },
              },
              "& .Mui-selected": {
                color: "#000 !important",
                backgroundColor: "transparent !important",
                border: "1.5px solid #000",
                boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
              },
            }}
          >
            <Tab
              icon={<CleaningServicesIcon sx={{ display: { xs: "block", sm: "none" }, fontSize: "28px" }} />}
              label={<Box sx={{ display: { xs: "none", sm: "block" } }}>Cleaning</Box>}
            />
            <Tab
              icon={<FactCheckIcon sx={{ display: { xs: "block", sm: "none" }, fontSize: "28px" }} />}
              label={<Box sx={{ display: { xs: "none", sm: "block" } }}>Cleaning Status</Box>}
            />
            <Tab
              icon={<MeetingRoomIcon sx={{ display: { xs: "block", sm: "none" }, fontSize: "28px" }} />}
              label={<Box sx={{ display: { xs: "none", sm: "block" } }}>Rooms</Box>}
            />
          </Tabs>
        </Box>

        <CleaningKanban />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Cleaning;
